export const CIRCLE_PROGRESS = {
    radius: 30,
    space: -5,
    outerStrokeGradient: true,
    outerStrokeWidth: 5,
    outerStrokeColor: '#00657c',
    outerStrokeGradientStopColor: '#53a9ff',
    innerStrokeColor: '#e7e8ea',
    innerStrokeWidth: 5,
    animateTitle: false,
    animationDuration: 1000,
    showUnits: false,
    showBackground: false,
    clockwise: true,
    startFromZero: false,
    showTitle: false,
    showSubtitle: false
};

export const PERSISTANT_STORAGE_KEY = {
    EMAIL_STUDENT: 'email_student',
    AUTH_TOKEN: 'auth_token',
};
export const GOAL_DATE = {
    PAST_GOAL: ' Past Goal Date',
    TODAY: ' Today',
    TOMORROW: ' Tomorrow',
    DAYS: ' days'
}
export const TOASTR = {
    timeOut: 2300,
    positionClass: 'toast-bottom-center'
}
